import { AccountLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const OfferAggregateBiddersFragment = graphql(
  `
    fragment OfferAggregateBidders on OfferAggregate {
      offerPrice {
        ...TokenPrice
      }
      totalValue {
        ...TokenPrice
      }
      totalOffers
      bidders {
        quantity
        imageUrl
        address
        ...AccountLockup
      }
    }
  `,
  [TokenPriceFragment, AccountLockupFragment],
)
